/*
 * File: Client.tsx
 * Project: a-a
 * File Created: Wednesday, 6th November 2024 9:36:02 pm
 * Author: Jackson Thounaojam (jackson.thounaojam@mutualmobile.com)
 * -----
 * Last Modified: Wednesday, 10th December 2025 6:31:43 pm
 * Modified By: Jackson Thounaojam (jackson.thounaojam@mutualmobile.com)
 * -----
 * Copyright 2020 - 2024 Mutual Mobile, Mutual Mobile
 */
import { Box, styled, Switch, Typography } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import ClientsList from '../../../components/featured/Client/ClientsList';
import CustomAlert from '../../../components/shared/CustomAlert/CustomAlert';
import CustomAlertContain from '../../../components/shared/CustomAlert/CustomAlertContain';
import CustomButton from '../../../components/shared/CustomButton/CustomButton';
import CustomHeadline from '../../../components/shared/CustomHeadline/CustomHeadline';
import CustomPopOver from '../../../components/shared/CustomPopOver/CustomPopOver';
import CustomTab from '../../../components/shared/CustomTab/CustomTab';
import { LightTooltip } from '../../../components/shared/CustomTooltip/CustomTooltip';
import { ClientService } from '../../../service/client.service';
import { DashboardService } from '../../../service/dashboard.service';
import { HuddleClientService } from '../../../service/huddle-client.service';
import zeplinColor from '../../../theme/Color';
import style from './Client.module.css';
import ClientDrawer from './ClientForm/FormDrawer/ClientDrawer';
import LinkingForm from './ClientForm/Forms/LinkingForm';
import NewClientType from './ClientForm/TypeModal/NewClientType';
type SportsProps = {
  link: '';
  title: '';
  source: '';
};
type ClientData = {
  clients: [
    {
      Name: string;
      AccountId: string;
      closedDealAmount: string | null;
      openDealAmount: string | null;
      category: string | null;
    },
  ];
};
const LayoutSwitch = styled(Switch)(({ theme }) => ({
  width: 92,
  height: 48,
  padding: 6,
  borderRadius: 50,
  border: `1px solid ${zeplinColor.Neutral6}`,
  backgroundColor: zeplinColor.Neutral1,
  '& .MuiSwitch-switchBase': {
    margin: 1,
    padding: 0,
    transform: 'translateX(6px)',
    '&.Mui-checked': {
      transform: 'translateX(44px)',
      '& + .MuiSwitch-track': {
        backgroundColor: 'transparent',
        opacity: 1,
        border: 0,
      },
    },
  },
  '& .MuiSwitch-thumb': {
    width: 40,
    height: 40,
    borderRadius: 20,
    backgroundColor: 'transparent',
  },
  '& .MuiSwitch-track': {
    borderRadius: 50,
    opacity: 1,
    backgroundColor: 'transparent',
    boxSizing: 'border-box',
  },
}));
const Client = () => {
  // const [loading, setLoading] = useState(false);
  const location = useLocation();
  const sf_token = sessionStorage.getItem('SFToken') || '';
  const sf_path = sessionStorage.getItem('sf_path') || '';
  const new_client = sessionStorage.getItem('new-client') || '';
  const platform_created = sessionStorage.getItem('platform') || '';
  const link_successful = sessionStorage.getItem('link-successful') === 'true';
  const [layout, setLayout] = useState<'column' | 'row'>('column');
  const [alert, setAlert] = React.useState('');
  const [value, setValue] = React.useState(0);
  const [anchorEl, setAnchorEl] = React.useState<HTMLDivElement | null>(null);
  const [modalOpen, setModalOpen] = React.useState(
    sf_token && sf_path && !new_client ? true : false,
  );
  const [drawerState, setDrawerState] = React.useState(false);
  const [typeSelected, setTypeSelected] = useState('Talent');
  const [platformSelected, setPlatformSelected] = useState(
    sf_token === 'true' && sf_path && !new_client ? 'Salesforce' : 'Huddle',
  );
  const [linkModal, setLinkModal] = useState(false);
  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
  };
  const [data, setData] = useState<any>({
    clients: [
      {
        Name: '',
        AccountId: '',
        closedDealAmount: null,
        openDealAmount: null,
        category: null,
      },
    ],
  });
  const [error, setError] = useState();
  const [loading, setLoading] = useState(false);
  const getAllClient = async () => {
    setLoading(true);
    try {
      const res: ClientData = await ClientService.getAllClient();
      const res2 = await HuddleClientService.getAllClient();
      console.log({ res2, res });
      setData({
        clients: [
          ...res?.clients.map((val: any) => ({ ...val, source: 'Salesforce' })),
          ...res2?.clients.map((val: any) => ({ ...val, source: 'Huddle' })),
        ].sort((a, b) => a?.Name.localeCompare(b?.Name)),
      });
    } catch (err: any) {
      setError(err);
    } finally {
      setLoading(false);
    }
  };

  const handleNewClientLink = () => {
    setAlert('');
    setLinkModal(true);
    setPlatformSelected('Huddle');
  };
  useEffect(() => {
    getAllClient();
  }, []);
  // sessionStorage.removeItem('captive8Id');
  // sessionStorage.removeItem('captive8Url');
  const ClientTabs = [
    {
      label: 'All',
      id: 1,
      isHidden: value !== 0,
      Component: (
        <Box>
          <ClientsList layout={layout} category={'all'} loading={loading} data={data} />
        </Box>
      ),
    },
    {
      label: 'Talent',
      id: 2,
      isHidden: value !== 1,
      Component: (
        <Box>
          <ClientsList layout={layout} category={'Talent'} loading={loading} data={data} />
        </Box>
      ),
    },
    {
      label: 'Athlete',
      id: 3,
      isHidden: value !== 2,
      Component: (
        <Box>
          <ClientsList layout={layout} category={'Athlete'} loading={loading} data={data} />
        </Box>
      ),
    },
    // {
    //   label: 'Business',
    //   id: 4,
    //   isHidden: false,
    //   Component: (
    //     <Box>
    //       <ClientsList layout={layout} category={'Business'} loading={loading} data={data} />
    //     </Box>
    //   ),
    // },
    {
      label: 'Business Development',
      id: 4,
      isHidden: value !== 3,
      Component: (
        <Box>
          <ClientsList
            layout={layout}
            category={'Business_Development'}
            loading={loading}
            data={data}
          />
        </Box>
      ),
    },
  ];
  const [sportsData, setSportsData] = React.useState<SportsProps[]>([
    {
      link: '',
      title: '',
      source: '',
    },
  ]);

  const getSportNews = async () => {
    try {
      const res: { latestNews: SportsProps[] } = await DashboardService.getSportNews();
      console.log(res);
      setSportsData(res?.latestNews);
    } catch (err) {
      console.log(err, 'err');
    }
  };
  const open = Boolean(anchorEl);
  const id = open ? 'simple-popover' : undefined;
  const handleTaskCreateClick = (event: React.MouseEvent<HTMLDivElement>) => {
    // console.log(event.currentTarget);
    // if (sf_token === 'true') {
    //   setModalOpen(true);
    // } else {
    //   setAnchorEl(event.currentTarget);
    // }
    setModalOpen(true);
  };
  const handleModalClose = (next = false) => {
    setModalOpen(false);
    sessionStorage.removeItem('sf_redirect');
    sessionStorage.removeItem('sf_edit');
    sessionStorage.removeItem('sf_delete');
    sessionStorage.removeItem('sf_path');
    !next && setPlatformSelected('Huddle');
  };
  const handleContinueAdd = () => {
    handleModalClose(true);
    setDrawerState(true);
    // sessionStorage.removeItem('sf_redirect');
    // sessionStorage.removeItem('sf_edit');
    // sessionStorage.removeItem('sf_delete');
  };
  // console
  React.useEffect(() => {
    getSportNews();
    new_client && setAlert('Client added');
    new_client && setTimeout(handleNewClientLink, 1000);
    link_successful && setAlert('Integrations connected');
    link_successful &&
      setTimeout(() => {
        setAlert('');
        sessionStorage.removeItem('link-successful');
      }, 2000);
    // sessionStorage.setItem('currentTab', '0');
  }, [new_client]);

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', height: '100vh' }}>
      {' '}
      <Box sx={{}}>
        <CustomHeadline sportsData={sportsData} />
      </Box>
      <Box
        sx={{
          padding: '24px 1.5rem 0rem 1.5rem',
          // height: '75vh',
          // display: 'flex',
          // flexDirection: 'column',
          // flex: 1,
          position: 'relative',
          overflow: 'auto',
        }}
      >
        {' '}
        <CustomTab tabs={ClientTabs} handleChange={handleChange} value={value} />
        <Box
          sx={{
            position: 'absolute',
            top: '1.5rem',
            right: '1.5rem',
            display: 'flex',
            gap: '16px',
          }}
        >
          {/* <CustomSearch /> */}
          {/* <Box
            sx={{
              borderRadius: '100px',
              border: `1px solid ${zeplinColor.Neutral6}`,
              padding: '10px',
              width: '48px',
              height: '48px',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              backgroundColor: zeplinColor.Neutral1,
            }}
          >
            <img src={`/assets/sort-icon.svg`} width='20px' height='20px' />
          </Box> */}
          <Box
            sx={{
              borderRadius: '50px',
              border: `1px solid ${zeplinColor.Neutral6}`,
              padding: '6px',
              width: { xs: '82px', xl: '92px' },
              height: { xs: '40px', xl: '48px' },
              display: 'flex',
              justifyContent: 'space-around',
              alignItems: 'center',
              backgroundColor: zeplinColor.Neutral1,
              position: 'relative', // Important for absolute positioning of slider
            }}
          >
            {/* Animated slider background */}
            <Box
              sx={{
                position: 'absolute',
                width: { xs: '35px', xl: '40px' },
                height: { xs: '28px', xl: '36px' },
                backgroundColor: zeplinColor.Brand1,
                opacity: 0.1,
                borderRadius: '40px',
                transition: 'transform 0.3s ease',
                transform:
                  layout === 'column'
                    ? 'translateX(0)'
                    : { xs: 'translateX(35px)', xl: 'translateX(40px)' },
                left: '6px',
              }}
            />

            {/* Column icon */}
            <Box
              onClick={() => setLayout('column')}
              sx={{
                zIndex: 1,
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                width: '40px',
                height: '100%',
                cursor: 'pointer',
                transition: 'all 0.2s ease',
              }}
            >
              <img
                src={
                  layout === 'column'
                    ? `/assets/selected-col-layout.svg`
                    : `/assets/column-layout-icon.svg`
                }
                className={layout === 'column' ? style['icons'] : style['selected-icons']}
                alt='Column layout'
                style={{
                  transition: 'all 0.2s ease',
                  transform: layout === 'column' ? 'scale(1.1)' : 'scale(1)',
                }}
              />
            </Box>

            {/* Row icon */}
            <Box
              onClick={() => setLayout('row')}
              sx={{
                zIndex: 1,
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                width: '40px',
                height: '100%',
                cursor: 'pointer',
                transition: 'all 0.2s ease',
              }}
            >
              <img
                src={
                  layout === 'row'
                    ? `/assets/selected-row-layout.svg`
                    : `/assets/row-layout-icon.svg`
                }
                className={layout === 'row' ? style['icons'] : style['selected-icons']}
                alt='Row layout'
                style={{
                  transition: 'all 0.2s ease',
                  transform: layout === 'row' ? 'scale(1.1)' : 'scale(1)',
                }}
              />
            </Box>
          </Box>
          <LightTooltip
            title={
              <Typography variant='responsiveBody3' color={zeplinColor.Neutral1}>
                New Client
              </Typography>
            }
            placement='bottom-end'
            style={{ backgroundColor: zeplinColor.BasicBlack, borderRadius: '8px' }}
            // sx={{ [`& .${tooltipClasses.tooltip}`]: { backgroundColor: zeplinColor.Neutral1 } }}
          >
            <Box sx={{ width: '100%' }}>
              <CustomButton
                disabled={false}
                onClick={handleTaskCreateClick}
                variant='contained'
                color={'primary'}
                buttonVariant='responsiveButtonLarge'
                style={{
                  width: '100%',
                  borderRadius: { xs: '10px', xl: '14px' },
                  height: { xl: 48 },
                  padding: { xs: '10px 12px', xl: '14px 16px' },
                  '&.Mui-focusVisible': { backgroundColor: '#333CAA' },
                }}
                textStyle={{ color: zeplinColor.Neutral1 }}
                text={'New Client'}
                icon={<img src={`/assets/add-white.svg`} className={style['add-icon']} />}
                // tabindex={4}
              />
            </Box>
          </LightTooltip>
        </Box>
      </Box>
      <CustomPopOver
        setAnchorEl={setAnchorEl}
        anchorEl={anchorEl}
        id={id}
        sx={{
          borderRadius: '14px',
          boxShadow: 'rgba(0, 0, 0, 0.15)',
          marginTop: '8px',

          // marginRight: '2rem',
          // marginLeft: '-4rem',
        }}
      >
        <Box
          sx={{
            // height: { xs: '170px', xl: '202px' },
            // zIndex: 1300,

            width: { xs: '300px', xl: '340px' },
            padding: { xs: '18px', xl: '24px' },
            display: 'flex',
            gap: { xs: '26px', xl: '32px' },
            flexDirection: 'column',
          }}
        >
          <Box sx={{ display: 'flex', gap: { xs: '10px', xl: '16px' }, flexDirection: 'column' }}>
            <Box sx={{ display: 'flex', gap: '12px', justifyContent: 'space-between' }}>
              <Typography variant='responsiveHeading3' color={zeplinColor.BasicBlack}>
                Authentication Required
              </Typography>
              <img
                src={'/assets/close-icon.svg'}
                className={style['icon-24']}
                alt='close'
                style={{ cursor: 'pointer' }}
                onClick={() => {
                  setAnchorEl(null);
                }}
              />
            </Box>

            <Typography variant='responsiveBody3' color={zeplinColor.BasicBlack}>
              {/* To create/edit a task, please ensure you're logged in to your Salesforce account. */}
              You need to be logged into Salesforce to perform this action. Please log in to your
              Salesforce account.
            </Typography>
          </Box>
          <Link
            // target='_blank'
            // rel='noopener noreferrer'
            to={`https://${process.env.REACT_APP_SALESFORCE_URI}/services/oauth2/authorize?client_id=${process.env.REACT_APP_CLIENT_SALESFORCE}&redirect_uri=${process.env.REACT_APP_REDIRECT}&response_type=code`}
          >
            <CustomButton
              disabled={false}
              onClick={() => {
                // sessionStorage.setItem('sf_redirect', 'Task');
                sessionStorage.setItem('sf_path', location?.pathname);
              }}
              variant='contained'
              buttonVariant='responsiveButtonLarge'
              color={'primary'}
              style={{
                width: { xs: '130px', xl: '155px' },
                borderRadius: { xs: '12px', xl: '14px' },
                height: { xs: '38px', xl: '48px' },
                padding: '14px 16px',
                '&.Mui-focusVisible': { backgroundColor: '#333CAA' },
              }}
              textStyle={{ color: zeplinColor.Neutral1 }}
              text={'Open Salesforce'}
              // tabindex={4}
            />
          </Link>
        </Box>
      </CustomPopOver>
      {modalOpen && (
        <NewClientType
          handleModalClose={handleModalClose}
          modalOpen={modalOpen}
          handleContinueAdd={handleContinueAdd}
          setTypeSelected={setTypeSelected}
          typeSelected={typeSelected}
          setPlatformSelected={setPlatformSelected}
          platformSelected={platformSelected}
          setAnchorEl={setAnchorEl}
          sf_token={sf_token}
        />
      )}
      {drawerState && (
        <ClientDrawer
          drawerState={drawerState}
          typeSelected={typeSelected}
          platformSelected={platformSelected}
          setDrawerState={setDrawerState}
          getAllClient={getAllClient}
          setPlatformSelected={setPlatformSelected}
        />
      )}
      {/* {loading ? (
        <CustomLoader
          open={loading}
          handleCloseModal={() => {
            setLoading(false);
          }}
        />
      ) : (
        ''
      )} */}
      <LinkingForm
        modalOpen={linkModal}
        clientId={new_client}
        platform_created={platform_created}
        setLinkModal={setLinkModal}
        getAllClient={getAllClient}
      />
      <CustomAlert
        open={alert ? true : false}
        handleClose={() => {
          setAlert('');
        }}
        message={
          <CustomAlertContain
            alertIcon={<img src='/assets/checkmark-green.png' width={24} height={24} />}
            alert={alert ? `${alert}` : ''}
          />
        }
        error={false}
      />
    </Box>
  );
};

export default Client;
